module.exports = __webpack_public_path__ + "img/NW16.c52ac140.jpg";